import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

class SizeGuideModalComponent extends DialogComponent {
  /** @type {HTMLElement | null} */
  #trigger = null;

  /** @type {Element | null} */
  #containerElement = null;

  connectedCallback() {
    super.connectedCallback();

    this.#containerElement = this.closest('variant-picker');
    this.#containerElement?.addEventListener('click', this.#handleClick);
    this.addEventListener(DialogCloseEvent.eventName, this.#restoreFocus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#containerElement?.removeEventListener('click', this.#handleClick);
    this.#containerElement = null;
    this.removeEventListener(DialogCloseEvent.eventName, this.#restoreFocus);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const openTrigger = event.target.closest('[data-size-guide-open]');
    if (openTrigger instanceof HTMLElement) {
      event.preventDefault();
      this.#trigger = openTrigger;
      this.showDialog();
      this.refs.closeButton?.focus();
      return;
    }

    if (event.target.closest('[data-size-guide-close]')) {
      event.preventDefault();
      this.closeDialog();
    }
  };

  #restoreFocus = () => {
    this.#trigger?.focus();
    this.#trigger = null;
  };
}

if (!customElements.get('size-guide-modal-component')) {
  customElements.define('size-guide-modal-component', SizeGuideModalComponent);
}
